import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "trainBanner"
}

import { ref, onMounted, computed, watch } from 'vue';
import type {Ref, ComputedRef} from 'vue';
import bannerDesktopTrain from '@/images/train_banner.png';
import bannerMobileTrain from '@/images/train_banner_mobile.png';
import { isMobile as checkIsMobile } from '@/utils/utils.js';
import {pfttPlusSevenCriteria} from '@/config/pfttPlusSevenCriteria';
import store from "@/vue/planning/store/store";
import { isSameTrainPackageType } from "@/config/trainPackageConfig";

// Setup reactive variables

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isMobile: Ref<boolean> = ref(false);
const isPFTT: Ref<boolean> = ref(false);

const checkIsPFTT = (): void => {
  const packageCode:string | null = store.state.packCode
  const hasBannerCriteria = window.lihe.criteriasList.includes(pfttPlusSevenCriteria)

  if (packageCode && (isSameTrainPackageType(packageCode, "PFTT") || packageCode === "HTT") && hasBannerCriteria) {
    isPFTT.value = true;
  } else {
    isPFTT.value = false;
  }
};

// Computed property for banner style
const bannerStyle: ComputedRef<string> = computed(() => {
  return `url(${isMobile.value ? bannerMobileTrain : bannerDesktopTrain})`
});

watch(
  () => store.state.packCode,
  () => {
    checkIsPFTT()
  }
);

onMounted(() => {
  isMobile.value = checkIsMobile();
  checkIsPFTT();
});

return (_ctx: any,_cache: any) => {
  return (isPFTT.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "banner",
          style: _normalizeStyle({ backgroundImage: bannerStyle.value })
        }, null, 4)
      ]))
    : _createCommentVNode("", true)
}
}

})